import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import I18nContext from './i18nContext';
import { useContentSingleEntry } from 'src/hooks/useContent';
import { APIResponse } from 'src/types/content';
import { TranslationKey } from './types';
import fallback from './fallback.json';
interface I18nProviderProps {
  children: React.ReactNode;
  initialLocale?: string;
}
const findTranslation = (translations: Record<string, unknown> | undefined, key: string, params?: Record<string, string | number | boolean>): string | undefined => {
  if (!translations) {
    return key;
  }
  const keyParts = key.split('.');
  let current: unknown = translations;
  for (const part of keyParts) {
    if (current && typeof current === 'object' && part in (current as Record<string, unknown>)) {
      current = (current as Record<string, unknown>)[part];
    } else {
      return key; // Return the key itself if not found
    }
  }
  let translation = typeof current === 'string' ? current : key;
  if (params) {
    Object.entries(params).forEach(([paramKey, value]) => {
      translation = translation.replace(new RegExp(`{{${paramKey}}}`, 'g'), String(value));
    });
  }
  return translation;
};
const I18nProvider: React.FC<I18nProviderProps> = t0 => {
  const $ = _c(10);
  const {
    children,
    initialLocale: t1
  } = t0;
  const initialLocale = t1 === undefined ? "en" : t1;
  const [locale, setLocaleState] = useState(initialLocale);
  const {
    isLoading,
    data,
    error
  } = useContentSingleEntry("api::frontend-i18n.frontend-i18n", locale);
  const fallbackTranslations = fallback.data["api::frontend-i18n.frontend-i18n"][0]?.published?.default;
  const createTranslationFunction = _temp;
  let t2;
  if ($[0] !== data) {
    t2 = createTranslationFunction(data, fallbackTranslations);
    $[0] = data;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t = t2;
  const loadingTranslations = isLoading && !fallbackTranslations;
  const t3 = !!error && !data;
  let t4;
  if ($[2] !== loadingTranslations || $[3] !== locale || $[4] !== t || $[5] !== t3) {
    t4 = {
      locale,
      loadingTranslations,
      translationsUnavailable: t3,
      t,
      setLocale: setLocaleState
    };
    $[2] = loadingTranslations;
    $[3] = locale;
    $[4] = t;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t4) {
    t5 = <I18nContext.Provider value={t4}>{children}</I18nContext.Provider>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default I18nProvider;
export type { I18nProviderProps };
function _temp(translations, fallbackTranslations_0) {
  return (key, params) => {
    if (!translations && !fallbackTranslations_0) {
      return key;
    }
    if (translations) {
      return findTranslation(translations.data, key, params) || key;
    } else {
      return findTranslation(fallbackTranslations_0, key, params) || key;
    }
  };
}